import _ from 'lodash'
import FolderSet from '../FolderSet.i18n';
import Schedule from '../Schedule.i18n';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

let exp = c => _.flattenDeep(_.concat([], c.child, _.map(c.child, exp)));
// 여기의 컨셉은 모든 설정을 한번에 다 하는 컨셉
export default {
  components: { FolderSet, Schedule },
  name: 'RuleQuickSetup',
  props: ['is_one','dir', 'is_first', 'scan_list', 'now_setting', 'os_type', 'white_path'],
  watch: {

    scan_list() {
      this.refresh()
    },
    now_setting() {
      this.refresh()
    },
    dir() {
      console.log('get path', this.dir.length)
    },
    step() {
      console.log('change step')

      if(this.step == 2) {
        // 에이전트에 목록 요청
        this.$parent.$emit('get_path', '')
      } else if(this.step == 3) {
        // 패스 검증
        if(this.scan_list.length < 1) {
          this.prev()
          return this.$toastr.w(`${i18n_toastr._i18n_warning.folder_check[this.i18n]}`)
        }
      } else if(this.step == 5) {
        console.log((!this.isolation || this.isolation.length < 1 ),  /(\/|\\)/.test(this.isolation) == false)
        if((!this.isolation || this.isolation.length < 1 ) || /(\/|\\)/.test(this.isolation) == false) {
          this.prev()
          return this.$toastr.w(`${i18n_toastr._i18n_warning.isolation[this.i18n]}`)
        }

        console.log(this.os_type, 'this.os_type')
        if(this.os_type.toLowerCase() == 'linux') {
          if( /(^[A-Z]:)/.test(this.isolation)) {
            // 경로가 윈도우면
            this.prev()
            return this.$toastr.w(`${i18n_toastr._i18n_warning.linux[this.i18n]}`)
          }
        }

        // 윈도우 일 경우 윈도우 폴더만 가능
        if(this.os_type.toLowerCase() != 'linux') {
          if( /(^[A-Z]:)/.test(this.isolation) == false) {
            // 경로가 윈도우가 아니면
            this.prev()
            return this.$toastr.w(`${i18n_toastr._i18n_warning.window[this.i18n]}`)
          }
        }

        if((/(\.\.{1,})/g.test(this.isolation) == true || this.isolation.indexOf('./') > -1)) {
          // 경로에 상대 경로가 있을 경우
          this.prev()
          return this.$toastr.w(`${i18n_toastr._i18n_warning.isolation_2[this.i18n]}`)
        }

      }
    },
  },
  data: () => {
    return {
      // css
      // step 1 : 그냥 설명, 처음 설치시만 보여줄 거임
      // step 2
      path : "",
      // step 3
      rule : [ "Hash", "Regex", "Url"],
      is_more : false,
      all_selected: true,
      rule_option: [
        { text: 'Regex', value: 'Regex' },
        { text: 'SSDEEP', value: 'Ssdeep' },
        { text: 'Hash', value: 'Hash' },
        { text: 'URL', value: 'Url' },
        { text: 'OBfuscation', value: 'OB' }
      ],
      // step 4
      isolation : '',
      // step 5
      schedule : [],
      // step 6
      modal_save : false,
      // common
      step : 1,
      all : 5,
      setting : {
        backup_mode: false,
        forgery_mode: true,
        realtime_mode: false,
        backup_path: '',
        rule: [],
        schedule: [],
        scan_list: [],
        white_path: [],
        ext_list: [],
        white_hash: [],
        snapshot: {
            watching: [],
            white_path: []
        }
      }
    }
  },
  computed: {
    rule_text: function() { return _.join(this.rule, ', ') }
  },
  methods: {
    style(color) {
      return `cursor:pointer;display: inline-block; background-color: ${color}; border:1px solid ${color}; width:100px; font-weight: 800; height:100px; border-radius:75px; text-align:center; margin:0 auto; font-size:15px; color:#fff; vertical-align:middle; line-height:100px`
    },
    // 여기서 커스텀 시작
    rule_update($value) {
      if(this.rule.indexOf($value) > -1) {
        this.rule = _.filter(this.rule, x => x != $value)
        console.log('no have it')
      } else {
        this.rule.push($value)
      }
    },
    //
    apply() {
      try {
        // 퀵설정 가능한 부분
        // 경로, 백업, 스케줄
        this.setting = Object.assign(
          {},
          this.setting,
          { rule : this.rule },
          // { scan_list : this.scan_list },
          // { white_path : this.white_path },
          { backup_path : this.isolation },
          // { backup_mode : this.isolation ? true : false },
          { backup_mode : false }, // 빠른 설정은 무조건 격리 모드 수동으로 설정
          { schedule : this.schedule },
        )

        // 저장 시그널 전송
        // console.log('this.setting',this.setting)
        this.$parent.$emit('save_quick', this.setting)
        this.$parent.$emit('status')
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_1[this.i18n]}`) }
    },
    list() {
      this.$router.push({ name: 'wsfinder_agent'});
    },
    next(step = undefined) {
      if(step) { this.step = step }
      else { this.step = this.step >= this.all ? this.all : this.step + 1 }
    },
    prev(step = undefined) {
      if(step) { this.step = step }
      else { this.step = this.step <= 0 ? 1 : this.step - 1 }
    },
    refresh() {
      // some action here
      this.setting = Object.assign({}, this.setting, this.now_setting)

      // console.log(this.setting)
      this.isolation = this.setting.backup_path
      this.rule = this.setting.rule
      // console.log(this.rule)
      if(this.rule.length < 1) {
        this.rule.push('Hash')
        this.rule.push('Url')
        this.rule.push('Regex')
      }
      this.schedule = this.setting.schedule
      if(this.scan_list) { this.setting.scan_list = this.scan_list }
      if(this.white_path) { this.setting.white_path = this.white_path }
      this.$parent.$emit("refresh")
      this.$forceUpdate()
      console.log('quick setting refreshed')
    },

    // 에이전트 설정과 호환
    add_scan_list(x) {
      if(_.indexOf(this.setting.scan_list, x.abs_path) > -1) {
        return this.$toastr.w(`${i18n_data._i18n_error.duplicate[this.i18n]}`)
      }
      this.setting.scan_list.push(x.abs_path)
      let t = _.find(exp({ child: this.dir }), { abs_path : x.abs_path })
      if(t) { t.selected = true }
      console.log("add_scan_list", x.abs_path)
    },
    add_white_list(x) {
      console.log(x, 'ssssx')

      if(_.indexOf(this.setting.white_path, x.abs_path) > -1) {
        return this.$toastr.w(`${i18n_data._i18n_error.duplicate[this.i18n]}`)
      }

      if(_.filter(this.setting.scan_list, y => {
        console.log(x.abs_path.replace(/\\/gm, ''), y.replace(/\\/gm, ''), _.startsWith(x.abs_path.replace(/\\/gm, ''), y.replace(/\\/gm, '')) == false)
        return _.startsWith(x.abs_path.replace(/\\/gm, ''), y.replace(/\\/gm, ''))
      }).length < 1) {
        // 해당 경로는 넣을 수 없음
        return this.$toastr.w(`${i18n_data._i18n_warning.warning[this.i18n]}`, `${i18n_toastr._i18n_warning.add_white_list[this.i18n]}`)
      }

      this.setting.white_path.push(x.abs_path)
      console.log("add_white_list", x.abs_path)
    },
    white_path_one(x) {
      console.log('add white path', x)
    },
    remove_select(type, s) {
      console.log('quick', type, s)
      if(type == 'scan_list') {
        // 예외 경로에 있을 경우 삭제 불가를 안내 해야 함
        if(_.filter(this.setting.white_path, y => _.startsWith(y.replace(/\\/gm, ''), s.replace(/\\/gm, '')) == true).length > 0) {
          // console.log(this.white_path, s)
          // 해당 경로는 삭제할 수 없음
          return this.$toastr.w(`${i18n_data._i18n_warning.warning[this.i18n]}`, `${i18n_toastr._i18n_warning.remove_select[this.i18n]}`)
        }
        this.setting.scan_list = _.filter(this.setting.scan_list, x => x != s);
      }

      if(type == 'white_path') {
        this.setting.white_path = _.filter(this.setting.white_path, x => x != s);
      }

      console.log(this.setting.scan_list)
    },
  },
  created: function() {   console.log('SettingQuickSetup.vue', 'created'); },
  destroyed: function() {
    console.log('SettingQuickSetup.vue', 'destroyed');
  },
  mounted: function() {
    console.log('SettingQuickSetup.vue', 'mounted');
    // 기존 설정 저장
    this.refresh()
    if(this.is_one) {
      this.step = 2
    }



    // 스탭별 디버깅용
    // if(location.hostname == 'localhost') {
    //   // this.is_more = true
    //   this.step = 5

    // }
  }
}
